<template>
  <v-card class="elevation-5 mb-4 py-3 px-5">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-layout row align-center justify-space-between>
          <h1
            class="subheading font-weight-black primary--text"
            :class="{
              'text-xs-center': $vuetify.breakpoint.xs,
              'margin-no-btn': isPlanDelete
            }"
          >
            BENEFICIÁRIO :
            {{ dadosBeneficiario.nome }}
          </h1>
          <h1
            class="subheading font-weight-black primary--text"
            v-if="exibeResponsavelLegal"
            :class="{
              'text-xs-center': $vuetify.breakpoint.xs,
              'margin-no-btn': isPlanDelete
            }"
          >
            RESPONSÁVEL LEGAL :
            {{ dadosBeneficiario.nomeResponsavel }}
          </h1>

          <v-btn
            :color="highContrast ? 'white' : 'primary'"
            @click="setTrocarBeneficiario()"
            outline
            class="hidden-xs-only"
            v-if="!isPlanDelete"
            >TROCAR BENEFICIÁRIO</v-btn
          >
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md6 lg3 xl3>
        <p
          class="body-2 font-weight-regular grey--text text--darken-2"
          :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
        >
          <b>Número do cartão</b>
          <br />
          {{ dadosBeneficiario.numeroCartao }}
        </p>
      </v-flex>
      <v-flex xs12 sm12 md6 lg3 xl3>
        <p
          class="body-2 font-weight-regular grey--text text--darken-2"
          :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
        >
          <b>Data de inicio de vigência</b>
          <br />
          {{ dadosBeneficiario.dataInicioVigencia | formatDate }}
        </p>
      </v-flex>
      <v-flex xs12 sm12 md6 lg3 xl3>
        <p
          class="body-2 font-weight-regular grey--text text--darken-2"
          :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
        >
          <b>Situação atual do beneficiário</b>
          <br />
          {{ dadosBeneficiario.ativo ? "Ativo" : "Inativo" }}
        </p>
      </v-flex>
      <v-flex xs12 sm12 md6 lg3 xl3>
        <p
          class="body-2 font-weight-regular grey--text text--darken-2"
          :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
        >
          <b>Número do contrato</b>
          <br />
          {{ dadosBeneficiario.contratoId }}
        </p>
      </v-flex>
      <v-flex xs12 sm12 md6 lg3 xl3>
        <p
          class="body-2 font-weight-regular grey--text text--darken-2"
          :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
        >
          <b>Plano</b>
          <br />
          {{ dadosBeneficiario.planoNomeComercial }}
        </p>
      </v-flex>
      <v-flex xs12 sm12 md6 lg3 xl3>
        <p
          class="body-2 font-weight-regular grey--text text--darken-2"
          :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
        >
          <b>Registro do plano na ANS</b>
          <br />
          {{ dadosBeneficiario.planoRegistroAns }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout
      row
      align-center
      justify-center
      class="hidden-sm-and-up"
      v-if="!isPlanDelete"
    >
      <v-btn
        :color="highContrast ? 'white' : 'primary'"
        outline
        @click="setTrocarBeneficiario()"
        >TROCAR BENEFICIÁRIO</v-btn
      >
    </v-layout>
    <v-layout class="justify-end" v-if="documentos">
      <v-flex xs12 sm12 md6 lg3 xl3>
        <p
          class="body-2 font-weight-regular grey--text text--darken-2"
          :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
          style="text-align: right;"
        >
          <span v-for="doc in documentos" :key="doc.id">
            <a class="download" @click="download(doc)">
              <b>{{ doc.documentTypeDescription }}</b>
              <br />
            </a>
          </span>
        </p>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { isMenorDeIdade } from "@/utils/date";
import api from "@/api/portal-beneficiario";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

export default {
  name: "BeneficiaryData",
  props: {
    isPlanDelete: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    this.$api
      .get(api.lgpdEnabled("portal-beneficiario"))
      .then(response => {
        this.documentos = response.data.documents;
      })
      .catch(error => {
        var errorMessage = error.response.data.message.split("|");
        this.setErrorToast(errorMessage);
      });
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario", "titularIncapaz"]),
    ...portalStore.mapState(["highContrast"]),
    exibeResponsavelLegal() {
      return (
        this.dadosBeneficiario.titular &&
        (this.titularIncapaz ||
          isMenorDeIdade(this.dadosBeneficiario.dataNascimento))
      );
    }
  },
  data() {
    return {
      documentos: []
    };
  },
  methods: {
    ...beneficiarioStore.mapMutations(["setTrocarBeneficiario"]),
    async download(param) {
      this.$api
        .get(api.lgpdDownload(param.uuid), {
          responseType: "blob"
        })
        .then(response => {
          const filename = param.documentTypeDescription;

          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");

          link.href = window.URL.createObjectURL(blob);
          link.download = filename.replace(/"/g, "");
          link.click();
        })
        .catch(errors => {
          if (errors && errors.length) {
            var errorMessage = errors.response.data.message.split("|");

            this.setErrorToast(errorMessage);
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.margin-no-btn {
  margin: 12px 0;
}
a.download {
  text-decoration: underline;
}
</style>
